import { dataBookBookmarkSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBookBookmarkSolid = /*#__PURE__*/createIcon(dataBookBookmarkSolid)
export default IconBookBookmarkSolid
